import { baseResources, baseResourceActions } from "routes/enum";

const { KB_POST_FORM, KB_POST_FORM_WORKFLOW } = baseResources;
const { READ, CREATE, UPDATE, DELETE } = baseResourceActions;

/** View post-forms */
export const POST_FORM_READ_PERMISSION = [`${READ}_${KB_POST_FORM}`];

/** Add new post-form */
export const POST_FORM_CREATE_PERMISSION = [`${CREATE}_${KB_POST_FORM}`];

/** Edit post-form (title) */
export const POST_FORM_UPDATE_PERMISSION = [`${UPDATE}_${KB_POST_FORM}`];

/** Edit post-form workflow */
export const POST_FORM_WORKFLOW_UPDATE_PERMISSION = [
    `${UPDATE}_${KB_POST_FORM_WORKFLOW}`,
];

/** Delete post-form */
export const POST_FORM_DELETE_PERMISSION = [`${DELETE}_${KB_POST_FORM}`];

export const POST_FORM_COLLECTION_TYPE = "POST_FORM_COLLECTION";

export const isPostFormBranchCollection = (branchCollectionType) =>
    branchCollectionType === POST_FORM_COLLECTION_TYPE;

export const POST_FORMS_PERMISSION_MAP = {
    "View post-forms": POST_FORM_READ_PERMISSION,
    "Add new post-form": POST_FORM_CREATE_PERMISSION,
    "Edit post-form (title)": POST_FORM_UPDATE_PERMISSION,
    "Edit post-form workflow": POST_FORM_WORKFLOW_UPDATE_PERMISSION,
    "Delete post-form": POST_FORM_DELETE_PERMISSION,
};
